module.exports = __webpack_public_path__ + "static/media/headercollage.d9d0a304.png";